import React from "react";
import styles from "../styles";
import localStyles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Button } from "@material-ui/core";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import Select from "../../../../../common/StyledSelect";
import { compose } from "recompose";
import GeocoderSearch from "../../../../Common/GeocoderSearchBox";
import CustomTextField from "../../DriverPopUp/common/CustomTextField";
import CustomBadge from "../../DriverPopUp/common/CustomBadge";
import { postData } from "../../../../../../api/componentAPIs";
import MESSAGES from "../../../../../../appMessages";
import Events from "../../../../../../utilities/EventEmitter";
import { withSnackbar } from "notistack";
import { getArrivedAtStopId, isTrailerDropFieldVisible } from "../utils";
import { getEquipmentSuffix } from "../../../utils/utils";
import { DROP_TRAILER_TYPE } from "../../constants";
class TrailerDropForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorInfo: {
        address: null,
        customerName: null,
        selectedCustomer: null,
        locationName: null,
        agentDetail: null,
        receiverName: null,
      },
      address: "",
      customerName: "",
      selectedCustomer: {},
      locationName: "",
      agentDetail: "",
      receiverName: "",
      customerOptions: [],
      dropAddress: {
        longitude: "",
        latitude: "",
        zip: "",
        city: "",
        state: "",
        address: "",
      },
    };
  }

  componentDidMount() {
    Events.on("equipmentDropped", this.equipmentDroppedStatus);

    const customers = this.getCustomers();
    this.setState({
      customerOptions: customers,
      selectedCustomer: customers.length ? customers[0] : {},
    });
  }

  componentWillUnmount() {
    Events.off("equipmentDropped", this.equipmentDroppedStatus);
  }

  equipmentDroppedStatus = (data) => {
    const { success } = data;
    if (success) {
      this.onEquipmentDropSucceed();
    } else {
      this.onEquipmentDropFailed();
    }
  };

  getLocationDetails = ({ longitude, latitude, zip, address, location }) => {
    if (longitude && latitude && address) {
      this.setState(
        {
          dropAddress: {
            longitude,
            latitude,
            zip,
            city: location.City,
            state: location.State,
            address: location.StreetAddress,
          },
        },
        () => this.handleChange("address")(address)
      );
    }
  };

  isDropAddressValid = () => {
    const {
      dropAddress: { longitude, latitude },
      address,
    } = this.state;
    return longitude && latitude && address;
  };

  handleChange = (field) => (value) => {
    this.setState(
      {
        [field]: value,
      },
      () => this.updateErrors(field,value)
    );
  };

  updateErrors = (field, value) => {
    this.setState((prevState) => ({
      errorInfo: {
        ...prevState.errorInfo,
        [field]: this.getIfValueRequired(field, value),
      },
    }));
  };

  getCustomers = () => {
    let stops = this.props.filteredStops.map((stop) => {
      return { label: stop.name, value: stop.name, stopId: stop.stopId };
    });
    stops.push({ label: "Other", value: "other", stopId: null });
    return stops;
  };

  getIfValueRequired = (filedName, value) => {
    if (filedName === "address") {
      if (!value) {
        return "* Required";
      } else if (!this.isDropAddressValid()) {
        return "* Invalid Address";
      }
      return null;
    }
    if (
      isTrailerDropFieldVisible(filedName, this.props.dropType, this.state) &&
      !value
    ) {
      return "* Required";
    }
    return null;
  };

  getErrors = () => {
    return {
      address: this.getIfValueRequired("address", this.state.address),
      selectedCustomer: this.getIfValueRequired("selectedCustomer", this.state.selectedCustomer),
      customerName: this.getIfValueRequired(
        "customerName",
        this.state.customerName
      ),
      locationName: this.getIfValueRequired(
        "locationName",
        this.state.locationName
      ),
      agentDetail: this.getIfValueRequired(
        "agentDetail",
        this.state.agentDetail
      ),
    };
  };

  onSubmit = () => {
    const errors = this.getErrors();
    this.setState({
      errorInfo: errors,
    });
    const hasValidInputs = Object.values(errors).every((v) => v === null);

    if (!hasValidInputs) {
      return;
    }

    this.props.showHideLoader(true);
    const { userData, routeData, dropType, dollyNumber, isDollyOnlyDrop } = this.props;
    const { dropAddress, receiverName } = this.state;

    const requestData = {
      terminalCode: userData.userProfile.terminal.code,
      driverId: routeData.driverId,
      dispatchId: routeData.dispatchId,
      routeId: routeData.routeId,
      stopId:  this.getStopId(),
      dropType: dropType,
      customerName: this.getCustomerName(),
      locationName: this.getLocationName(),
      dropAddress: dropAddress.address,
      dropCity: dropAddress.city,
      dropState: dropAddress.state,
      dropZip: dropAddress.zip,
      longitude: dropAddress.longitude,
      latitude: dropAddress.latitude,
      dollyNumber,
      dollyScac: routeData.dollyScac ?? null,
      isDollyOnlyDrop,
      receiverName,
    };
    postData("TrailerDrop", requestData)
      .then((response) => {
        if (response?.status !== 204) {
          this.onEquipmentDropFailed(response.status);
        }
      })
      .catch(() => {
        this.onEquipmentDropFailed();
      });
  };

  getLocationName = () => {
    const { locationName, selectedCustomer, customerName, agentDetail } = this.state;
    const { dropType } = this.props;
    if (dropType == DROP_TRAILER_TYPE.TemporaryLocation) {
      return locationName;
    } else if (dropType === DROP_TRAILER_TYPE.AgentInterline) {
      return agentDetail;
    } else if (selectedCustomer.value === "other") {
      return customerName;
    }
    return selectedCustomer.value;
  };

  getCustomerName =()=>{
    const { dropType } = this.props;
    const { selectedCustomer, customerName, agentDetail } = this.state;
    if (dropType === DROP_TRAILER_TYPE.AgentInterline) {
      return agentDetail;
    } else if (selectedCustomer.value === "other") {
      return customerName;
    }
    return selectedCustomer.value;
  }

  getStopId = () => {
    const { routeData, dropType } = this.props;
    const { selectedCustomer } = this.state;
    const arrivedStopId = getArrivedAtStopId(routeData);
    if (arrivedStopId) {
      return arrivedStopId;
    }
    if (isTrailerDropFieldVisible('selectedCustomer', dropType)) {
      return selectedCustomer.stopId;
    }
    return null;
  };

 onEquipmentDropFailed = (statusCode) => {
    this.props.showHideLoader(false);
    if (statusCode === 403) {
      return;
    } 
    const message = this.props.enableDollyDropAndHook
      ? MESSAGES.EQUIPMENT_DROP.FAILURE
      : MESSAGES.TRAILER_DROP.FAILURE;
    this.props.enqueueSnackbar(message, {
      variant: "error",
    });
  };

  onEquipmentDropSucceed = () => {
    const message = this.props.enableDollyDropAndHook
      ? MESSAGES.EQUIPMENT_DROP.SUCCESS
      : MESSAGES.TRAILER_DROP.SUCCESS;
    this.props.enqueueSnackbar(message, {
      variant: 'success'
    });
    this.props.showHideLoader(false);
    this.props.goBack();
    this.props.clearSelectedEquipments();
  };

  onClearSearch = (value = "") => {
    this.setState(
      {
        dropAddress: {
          longitude: "",
          latitude: "",
          zip: "",
          city: "",
          state: "",
          address: "",
        },
      },
      () => this.handleChange("address")(value)
    );
  };

  render() {
    const {
      classes,
      trailerNumber,
      dollyNumber,
      shipmentData,
      isLoading,
      dropType,
      routeData,
      showTrailerScac,
      enableDollyDropAndHook,
    } = this.props;
    const { totalBills, totalPieces, totalHu, totalWeight } = shipmentData;
    const { errorInfo, customerOptions } = this.state;
    const theme = this.props.userData.userProfile.theme;
    const trailerNumberWithScacCode = trailerNumber
      ? `${trailerNumber} ${getEquipmentSuffix({
          equipmentScac: routeData.trailerScac,
          showTrailerScac
        })}`
      : null;
    const dollyNumberWithScacCode = dollyNumber
      ? `${dollyNumber} ${getEquipmentSuffix({
          equipmentScac: routeData.dollyScac,
          showTrailerScac
        })}`
      : null;
    return (
      <React.Fragment>
        <Grid container className={classes.innerContainer}>
          <Grid xs={12}>
            <div className={classes.headerText}>
              {enableDollyDropAndHook ? 'EQUIPMENT DETAILS': 'TRAILER DETAILS'}
            </div>
            <div className={classes.subHeaderText}>
              {trailerNumberWithScacCode && (
                <span className={classes.trailerMarginRight}>
                  TRAILER# {trailerNumberWithScacCode}
                </span>
              )}
              {dollyNumberWithScacCode && <span>DOLLY# {dollyNumberWithScacCode}</span>}
            </div>
            <div className={`${classes.flexRow} ${classes.trailerData}`}>
              <div className={classes.trailerInfo}>
                <CustomBadge
                  value={totalBills ? totalBills : "0"}
                  labelText="Bills"
                />
                <CustomBadge
                  value={totalPieces ? totalPieces : "0"}
                  labelText="Pieces"
                />
                <CustomBadge value={totalHu ? totalHu : "0"} labelText="HU" />
                <CustomBadge
                  value={totalWeight ? totalWeight : "0"}
                  labelText="LBS"
                />
              </div>
            </div>
          </Grid>
          <Grid xs={12}>
            <div className={classes.headerText}>LOCATION DETAILS</div>
            <div className={classes.searchRow}>
              <div
                className={`${classes.editorContainer} ${
                  Boolean(errorInfo?.address) && "error"
                }`}
              >
                <GeocoderSearch
                  getLocationDetails={this.getLocationDetails}
                  inputValue={this.state.address}
                  geocoderTheme={theme.themeName}
                  error={Boolean(errorInfo?.address)}
                  onClear={this.onClearSearch}
                ></GeocoderSearch>
                {Boolean(errorInfo?.address) && (
                  <div
                    className={`MuiFormHelperText-root MuiFormHelperText-error ${classes.errorMessageVisible}`}
                  >
                    {errorInfo?.address}
                  </div>
                )}
              </div>
            </div>
          </Grid>
          {isTrailerDropFieldVisible("locationName", dropType) ? (
            <Grid xs={12}>
              <div className={classes.headerText}>Location Name</div>
              <div className={classes.flexRow}>
                <CustomTextField
                  label="Location Name"
                  value={this.state.locationName}
                  handleChange={this.handleChange("locationName")}
                  error={this.state.errorInfo?.locationName}
                  margin="dense"
                />
              </div>
            </Grid>
          ) : null}
          {isTrailerDropFieldVisible("agentDetail", dropType) ? (
            <Grid xs={12}>
              <div className={classes.headerText}>Agent/Interline Details</div>
              <div className={classes.flexRow}>
                <CustomTextField
                  label="Agent/Interline Name"
                  value={this.state.agentDetail}
                  handleChange={this.handleChange("agentDetail")}
                  error={this.state.errorInfo?.agentDetail}
                  margin="dense"
                />
              </div>
            </Grid>
          ) : null}
          <Grid xs={12}>
            {isTrailerDropFieldVisible("selectedCustomer", dropType) ? (
              <>
                <div className={classes.headerText}>CUSTOMER DETAILS</div>
                <div className={classes.flexRow}>
                  <Select
                    textFieldProps={{
                      id: "Selected Customer",
                      label: "",
                      variant: "outlined",
                    }}
                    value={this.state.selectedCustomer.value || null}
                    onChange={this.handleChange("selectedCustomer")}
                    error={Boolean(this.state.errorInfo?.selectedCustomer)}
                    helperText={this.state.errorInfo?.selectedCustomer}
                    data={customerOptions}
                    isNotClearable
                    margin="dense"
                    rootClass={classes.selectRoot}
                  />
                </div>
              </>
            ) : null}

            {this.state.selectedCustomer.value === "other" &&
            isTrailerDropFieldVisible("customerName", dropType, this.state) ? (
              <div className={classes.flexRow}>
                <CustomTextField
                  label="Customer Name"
                  value={this.state.customerName}
                  handleChange={this.handleChange("customerName")}
                  error={this.state.errorInfo?.customerName}
                  margin="dense"
                />
              </div>
            ) : null}
          </Grid>
          {isTrailerDropFieldVisible("receiverName", dropType) ? (
            <Grid xs={12}>
              <div className={classes.headerText}>RECEIVER DETAILS</div>
              <div className={classes.flexRow}>
                <CustomTextField
                  label="Receiver Details"
                  value={this.state.receiverName}
                  handleChange={this.handleChange("receiverName")}
                  error={this.state.errorInfo?.receiverName}
                  margin="dense"
                />
              </div>
            </Grid>
          ) : null}

          <Button
            color="primary"
            variant="contained"
            fullWidth
            className={`${classes.confirmButton} ${classes.completeDropButton}`}
            onClick={this.onSubmit}
            disabled={isLoading}
            classes={{
              disabled: classes.disabledConfirmButton,
            }}
          >
            COMPLETE DROP
          </Button>
        </Grid>
      </React.Fragment>
    );
  }
}

export default compose(
  withSnackbar,
  withUserProfile,
  withStyles(
    (theme) => ({
      ...styles(theme),
      ...localStyles(theme),
    }),
    { withTheme: true }
  )
)(TrailerDropForm);
